import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { openModalFn } from '../../../../../utils/controllers/ModalController'

type PhotosViewBlockProps = {
  collection: any[]
  urls: any[]
  name: string
}

const PhotosViewBlock: FC<PhotosViewBlockProps> = ({
  collection,
  name,
  urls,
}) => {
  const onImgClick = (i: number) => {
    openModalFn['photo-gallery']?.({
      collection,
      initialIndex: i,
      name,
    })
  }

  return (
    <>
      {!!collection?.length && (
        <Box>
          <Typography
            variant={'body2'}
            color={'grey.500'}
            sx={{ marginY: '4px', lineHeight: 1 }}
          >
            {name}
          </Typography>
          <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            {urls?.map((url: string, i: number) => {
              return (
                <img
                  style={imgStyles}
                  src={url}
                  onClick={() => onImgClick(i)}
                  key={i}
                />
              )
            })}
          </Box>
        </Box>
      )}
    </>
  )
}

const imgStyles = {
  width: '64px',
  height: '64px',
  borderRadius: '8px',
  border: '1px solid gray',
  cursor: 'pointer',
}

export default observer(PhotosViewBlock)
